import {Injectable} from '@angular/core';
import {Observable, of, Subject} from 'rxjs';

declare var UIkit: any;
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor() {
  }

  confirm(message?: string): Observable<boolean> {
    $('body').addClass('cancel-transaction');
    var subject = new Subject<boolean>();
    const confirmation = UIkit.modal.confirm(message || 'Are you sure?', {labels: {ok: 'Yes', cancel: 'No'}}).then(f => {
      console.log('Confirmed.');
      $('body').removeClass('cancel-transaction');
      subject.next(true);
    }, f => {
      $('body').removeClass('cancel-transaction');
      subject.next(false);
    });

    return subject.asObservable();

    // const confirmation = window.confirm(message || 'Are you sure?');
    // return of(confirmation);
  }
}
